import { render } from "./updateHome.vue?vue&type=template&id=33bda5b4&scoped=true"
import script from "./updateHome.vue?vue&type=script&lang=js"
export * from "./updateHome.vue?vue&type=script&lang=js"

import "./updateHome.vue?vue&type=style&index=0&id=33bda5b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bda5b4"]])

export default __exports__